import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Skip auth interceptor for translation files (static assets)
  if (req.url.includes('/assets/i18n/')) {
    return next(req);
  }

  const auth = inject(AuthService);
  const token = auth.token();

  const authReq = token
    ? req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      })
    : req;

  return next(authReq).pipe(
    catchError(err => {
      if (err?.status === 401) {
        const isEmailResponseApi = req.url.includes('email-responses');
        const isEmailResolutionResponsesApi = req.url.includes('email-resolution-responses');
        if (!isEmailResponseApi && !isEmailResolutionResponsesApi) {
          auth.handleUnauthorized();
        }
      }
      return throwError(() => err);
    })
  );
};


